var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t(_vm.title),
      "ok-text": _vm.$t("确定"),
      "cancel-text": _vm.$t("取消"),
      width: 800,
      closable: false,
      maskClosable: false,
      "confirm-loading": _vm.confirmLoading
    },
    on: {
      ok: _vm.confirmModal,
      cancel: _vm.cancleModal
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 19
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("文件名称"),
      maxLength: 50
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("name");
      }
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件内容"),
      prop: "fileContent"
    }
  }, [_c("quillEditor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "540px"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.form.fileContent,
      callback: function ($$v) {
        _vm.$set(_vm.form, "fileContent", $$v);
      },
      expression: "form.fileContent"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("链接文件")
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-around"
    }
  }, [_c("a-select", {
    staticStyle: {
      flex: "1",
      overflow: "hidden"
    },
    attrs: {
      "show-search": "",
      placeholder: _vm.$t("请选择") + _vm.$t("链接文件"),
      "option-filter-prop": "children",
      allowClear: true
    },
    on: {
      change: _vm.fileChange
    }
  }, _vm._l(_vm.fileList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1), _c("a-button", {
    staticClass: "copyBtn",
    attrs: {
      size: "small"
    },
    on: {
      click: function ($event) {
        $event.stopPropagation();
        return _vm.handleCopy(`${_vm.fileId}`, $event);
      }
    }
  }, [_c("a-icon", {
    attrs: {
      type: "copy"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("复制链接")) + " ")], 1)], 1)])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };